/**
 * Stripe Controller
 * Defines the interface for using Stripe for processing payments
 */

// Import API singleton and appropriate resource interface
import api, { resolveWithStatus } from "@/services/api/api";

const createCheckoutSession = async (
  packageName: String,
  accessToken: any
): Promise<any> => {
  try {
    const body = {
      packageName
    };

    const checkoutSession = (
      await api.post("/stripe/", body, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    ).data;

    return checkoutSession;
  } catch (error) {
    console.log("ERROR: stripe.createCheckoutSession failed");
    console.log(error);

    throw error;
  }
};

const showSession = async (
  sessionID: String,
  accessToken: String
): Promise<any> => {
  try {
    const checkoutSessionInformation = (
      await api.get(`/stripe/${sessionID}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    ).data;

    return checkoutSessionInformation;
  } catch (error) {
    console.log("ERROR: stripe.showSession failed");
    console.log(error);

    throw error;
  }
};

//  Export all action
export default {
  createCheckoutSession,
  showSession
};
